import { $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isMobile } from '../../utils/check-media'

const ZOOM_TARGET_SELECTOR = `[data-zoom-cursor-target]`

export class ZoomCursor extends BaseComponent {
  mutationObserver: MutationObserver

  constructor() {
    super()
    this.mutationObserver = new MutationObserver(this.handleMutations)
  }

  mountComponent(): void {
    this.addListener(window, 'mousemove', this.handleMouseMove)
  }

  unmountComponent(): void {
    this.mutationObserver.disconnect()
  }

  handleMutations = (mutations): void => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        this.setVisible(mutation.target.matches(ZOOM_TARGET_SELECTOR))
      }
    })
  }

  handleMouseMove = (event: MouseEvent): void => {
    const target = event.target as HTMLElement
    const isTarget = !!$elParent(ZOOM_TARGET_SELECTOR, target)

    if (!isMobile()) {
      this.setVisible(isTarget)

      if (this.isVisible) {
        this.style.top = `${event.clientY}px`
        this.style.left = `${event.clientX}px`
      }
    }

    if (isTarget) {
      this.mutationObserver.observe(target, {
        attributes: true,
      })
    } else {
      this.mutationObserver.disconnect()
    }
  }

  setVisible(isVisible: boolean): void {
    this.classList.toggle('is-visible', isVisible)
    document.body.style.cursor = isVisible ? 'none' : ''
  }

  updateState(isZoomed: boolean): void {
    this.toggleAttribute('zoomed', isZoomed)
  }

  get isVisible(): boolean {
    return this.classList.contains('is-visible')
  }
}
